export const cookies = {
  prefix: 'BUA_BASKET_',
  current: 'BUA_BASKET_CURRENT',
  expires: 1 / 24
};
